<div class="container">
  <div class="head">
    {{ 'MENU_EDIT.HEADER' | translate }}
  </div>
  <div class="tab-header">
    <a
      [routerLink]="['modifier-group']"
      routerLinkActive="active-tab"
      class="tab-link"
    >{{ 'MENU_EDIT.MODIFIER_GROUPS' | translate }}</a>
    <a
      [routerLink]="['promo']"
      routerLinkActive="active-tab"
      class="tab-link"
    >{{ 'MENU_EDIT.PROMO' | translate }}</a>
    <a
      [routerLink]="['allergen-groups']"
      routerLinkActive="active-tab"
      class="tab-link"
    >{{ 'MENU_EDIT.ALLERGEN_GROUPS' | translate }}</a>
    <a
      [routerLink]="['default-images']"
      routerLinkActive="active-tab"
      class="tab-link"
    >{{ 'MENU_EDIT.DEFAULT_IMAGES' | translate }}</a>
    <a
      [routerLink]="['rp-programs']"
      routerLinkActive="active-tab"
      class="tab-link"
    >{{ 'MENU_EDIT.RP_PROGRAMS' | translate }}</a>
  </div>
  <div class="tab-content">
    <router-outlet></router-outlet>
  </div>
</div>
